import { RemixBrowser } from '@remix-run/react'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'

if (
	ENV.MODE === 'production' &&
	ENV.SENTRY_DSN &&
	ENV.SENTRY_DSN !== 'your-dsn'
) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

async function enableMocking() {
	if (ENV.MOCKS === 'true') {
		const { worker } = await import('../tests/mocks/browser.ts')
		return worker.start({
			onUnhandledRequest: (request) => {
				// Only warn for external API requests, not internal dev server requests
				const url = new URL(request.url)

				// Ignore internal development requests
				if (
					url.pathname.startsWith('/__') || // Vite dev server
					url.pathname.startsWith('/node_modules') || // Module imports
					url.pathname.includes('_data=') || // Remix data requests
					url.pathname.endsWith('.tsx') || // Source files
					url.pathname.endsWith('.ts') || // Source files
					url.pathname.endsWith('.js') || // Module files
					url.hostname === 'localhost' || // Local dev server
					url.hostname === '127.0.0.1' // Local dev server
				) {
					return // Ignore silently
				}

				// Only warn for actual external API requests
				console.warn(
					`[MSW] Unhandled external request: ${request.method} ${request.url}`,
				)
			},
		})
	}
}

void enableMocking().then(() => {
	startTransition(() => {
		hydrateRoot(document, <RemixBrowser />)
	})
})
